import DataFetcherTemplate from "../../hooks/fetchTemplate";
import BannerGeneral from "../../components/BannerGeneral";
import ModalFixed from "../../components/ModalFixed";
import BlockBackgroundImage from "../../components/BlockBackgroundImage";
import BlockImageCabecera from "../../components/BlockImageCabecera";
import FixedNotification from "../../components/FixedNotification";
import Notification from "../../components/Notification";

import Breadcumbs from "../../components/Breadcumbs";
import { NavLink } from "react-router-dom";

import ConectUs from "../../components/ConectUs";

import TecPagos from "../../components/TecPagos";
import ImageGallery from "../../components/ImageGallery";
import OfferTec from "../../components/view/OfferTec";
import OfferTec2 from "../../components/view/OfferTec2";

function Tecnologias() {
  const DataDisplay = ({ data }) => (
    <>
      <div>
        {data.map((item, index) => (
          <div>
            <BlockImageCabecera
              src={item.field_portada}
              title={
                <>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: item.field_texto_portada,
                    }}
                  />
                </>
              }
            ></BlockImageCabecera>
            <div className="relative">
              <Notification
                content={
                  <div
                    className="layout8"
                    dangerouslySetInnerHTML={{
                      __html: item.field_bloque1,
                    }}
                  />
                }
              ></Notification>

              <ModalFixed
                title="Proceso de matrícula 📝"
                color="#5854a7"
                content={
                  <>
                    <div className="width400">
                      <ImageGallery
                        gallery={item.field_gallery1}
                      ></ImageGallery>
                    </div>
                  </>
                }
              ></ModalFixed>
            </div>{" "}
            <Breadcumbs
              content={
                <>
                  <NavLink to="/tecnologias">Tecnologías</NavLink>
                </>
              }
            ></Breadcumbs>
            <div
              className="layout8"
              dangerouslySetInnerHTML={{
                __html: item.field_bloque2,
              }}
            />
            <div className="layout8">
              <center>
                <h3>
                  Periodo <b> enero - marzo 2026</b>{" "}
                </h3>
              </center>
            </div>
            <OfferTec></OfferTec>
            <div className="layout8 margin">
              <center>
                <h3>
                  Periodo <b>abril - agosto 2026</b>
                </h3>
              </center>
            </div>
            <OfferTec2></OfferTec2>
            <div className="padding">
              <TecPagos></TecPagos>
            </div>
            <div className="margin">
              <BlockBackgroundImage
                src={item.field_imagen3}
                content={
                  <div
                    className="layout8"
                    dangerouslySetInnerHTML={{
                      __html: item.field_bloque3,
                    }}
                  />
                }
              ></BlockBackgroundImage>
            </div>
          </div>
        ))}
      </div>
    </>
  );

  return (
    <>
      <DataFetcherTemplate url="https://utpl.edu.ec/carreras/oferta/servicio-tecnologias.json">
        {(data) => <DataDisplay data={data} />}
      </DataFetcherTemplate>
      {/*   <FixedNotification
        link="https://matriculas.utpl.edu.ec/"
        content={
          <>
            <img src="https://utpl.edu.ec/recursos/img/web-matriculas.png"></img>
          </>
        }
      ></FixedNotification> */}
      <ConectUs
        facebook="https://www.facebook.com/utpltec/"
        instagram="https://www.instagram.com/utpltec/"
        tiktok="https://www.tiktok.com/@utpltec"
        x="https://twitter.com/utpl?lang=es"
        youtube="https://www.youtube.com/user/utpl/"
        linkedin="https://www.linkedin.com/company/utpl-tec/"
      ></ConectUs>
      <BannerGeneral></BannerGeneral>
    </>
  );
}

export default Tecnologias;
